import { ReactComponent as Logo } from './quizIcon.svg';


const QuizLogo = (props :any) => (
  <div>
    <Logo fill={props.color} height="30px" />
  </div>
);
export default QuizLogo;